enum AssessmentStatuses {
  Published,
  'Not published',
}

export default AssessmentStatuses;
